import { LoadingEnum } from './dtos';

export const initialState = {
  list: [],
  loading: LoadingEnum.DEFAULT,
  pagination: null,
};
